module.exports = __webpack_public_path__ + "static/media/person5.ab45b1c9.jpg";